(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.tpgVideoModal = {
    attach: function (context, settings) {
      once('tpg-video-modal', '.tpg-video__modal', context).forEach(function (modal) {
        UIkit.util.on(modal, 'shown', function () {
          modal.style.display = 'flex';
        });

        UIkit.util.on(modal, 'hide', function () {
          var video = modal.querySelector('video');
          if (video) {
            video.pause();
          }
        });
      });

      once('tpg-video-inline', '[data-tpg-video-inline]', context).forEach(function (container) {
        var playBtn = container.querySelector('.tpg-video__play-btn--inline');
        var thumbnail = container.querySelector('.tpg-video__thumbnail');
        var player = container.querySelector('.tpg-video__inline-player');
        if (playBtn && thumbnail && player) {
          playBtn.addEventListener('click', function () {
            thumbnail.hidden = true;
            player.hidden = false;
            var video = player.querySelector('video');
            if (video) {
              video.play();
            }
          });
        }
      });
    }
  };

})(Drupal, once);